import BreadCrumbs, { IBreadcrumbs } from 'ui/components/molecules/Breadcrumbs';
import FaqAccordion, { IFaq } from 'ui/components/molecules/FaqAccordion';
import ArticleListTabSection from '../../organism/ArticleListTabSection';
import InfoSection from '../../organism/InfoSection';
import { useRouter } from 'next/router';
import ArrowLeftLogin from '../../atoms/Icons/ArrowLeftLogin';

interface IArticleListingPageProps {
  articles: {
    id?: string | number;
    titlePage?: string;
    slug?: string;
    publishedDate?: string;
    heroImageLink?: string;
    altImage?: string;
    contentCategory?: {
      name?: string;
    };
  }[];
  faqTitle: string;
  faq: IFaq[];
  categoryType: string;
  totalData: number;
  totalPages: number;
  breadcrumbItems: IBreadcrumbs[];
  info: {
    title: string;
    desc: string;
  };
  header: {
    title?: string;
    content?: string;
  };
  pageSize: number;
  paginationBaseUrl: string;
  newsHero: {
    titlePage?: string;
    publishedDate?: string;
  };
  showBackButton?: boolean;
  tabClassname?: string;
  feature?: string;
}

const ArticleListingPage = ({
  articles,
  faqTitle,
  faq,
  categoryType,
  totalData,
  totalPages,
  breadcrumbItems,
  info,
  header,
  pageSize,
  paginationBaseUrl,
  newsHero,
  showBackButton = false,
  tabClassname,
  feature,
}: IArticleListingPageProps) => {
  const router = useRouter();

  const page = router?.query?.page || '1';
  const category =
    router?.query?.kategori && typeof router?.query?.kategori === 'string'
      ? router?.query?.kategori?.split('-').join(' ').toUpperCase()
      : 'SEMUA';

  const currentPage = parseInt(page as string);

  const emarsysData = {
    pageTitle: header?.title || '',
    category: category,
    page_number: currentPage,
  };

  return (
    <>
      {/* Breadcrumb for web screen */}
      <BreadCrumbs isMobileScreen={false} items={breadcrumbItems} />
      {showBackButton && (
        <div className="container mb-[11px] border-b-[0.25px] border-reliableBlack10 flex justify-start items-center w-full pt-2 pb-2 sticky top-[60px] md:top-[111px] z-30 bg-white md:hidden">
          <button className="h-full" onClick={() => router.back()} aria-label="back button">
            <ArrowLeftLogin size={24} fill="#3D4043" />
          </button>
        </div>
      )}

      {/* List Artikel Desktop */}
      <ArticleListTabSection
        header={header}
        itemList={articles}
        categoryType={categoryType}
        totalData={totalData}
        totalPages={totalPages}
        pageSize={pageSize}
        paginationBaseUrl={paginationBaseUrl}
        newsHero={newsHero}
        tabClassname={tabClassname}
        feature={feature}
        emarsysData={emarsysData}
      />

      {/* Info section */}
      <InfoSection info={info} feature={feature} impressionData={emarsysData} />

      {/* FAQ section */}
      <FaqAccordion
        title={faqTitle}
        faqs={faq}
        containerClassname="mt-10 mb-[47.72px] lg:my-20"
        feature={feature}
        impressionData={emarsysData}
      />

      {/* Breadcrumb for mobile screen */}
      <BreadCrumbs isMobileScreen={true} items={breadcrumbItems} />
    </>
  );
};
export default ArticleListingPage;
